import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts  from 'react-highcharts';
import moment from "moment";
import { number } from "../../../utils";

import styles from "./styles.scss";
import ToggleChartSeries from '../../ToggleChartSeries/ToggleChartSeries';

let count = 0;
const idPrefix = "liveLineChart";

const dateFormat = "dddd, MMM Do, h:mm A";

const config = {
    chart:{
        animation: false,
        marginBottom: 85,
        zoomType: "x",
        panning: true,
        panKey: 'shift',
        style: {
            fontFamily: "Helvetica",
        }
    },
    credits: {
        enabled: false,
    },
    colors: ['#2D9BB1', '#556CAB', '#0F2748'],
    title: {
      text: "Ambient Conditions",
      align: "left",
      margin: 60,
      style: {
          "color": "#4D4D4D",
          "font-size": "20px",
          "font-weight": "600"
      },
	 },
	 plotOptions: {
		line: {
			marker: {
				enabled: false
			}
		}
	},
    tooltip: {
        followTouchMove: false,
        formatter: function () {
            return '<span style="font-size:10px">'
                + moment(this.x).utc().format(dateFormat) + 
                '</span><br/>'
                + '<br/><span style="color:'
                + this.series.color
                + ';">\u25CF\xa0</span>'
                + '<b>' + number.parseNumber(this.y) + this.series.userOptions.units + '</b>';
        },
    },
    legend: {
        itemStyle: {
            color: '#999',
            fontWeight: 'normal',
            fontSize: '14px',
        }
    },
    xAxis: {
        type: 'datetime',
        tickWidth: 0,
        lineColor: '#e6e6e6',
        dateTimeLabelFormats: {
            hour: '%l%P',
            day: '%e %b',
        },
        labels: {
            y: 30,
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    series: [ ],
  };

@CSSModules(styles, { allowMultiple: true })
class LiveLineChart extends Component {
    constructor(props){
        super(props);
        this.chart = React.createRef();
    }
    
	render() {
		return (
            <div>
                <ReactHighcharts
                    config={config}
                    ref={this.chart}
                    isPureConfig={true}
                />
                <ToggleChartSeries chart={this.chart} />
            </div>
		);
    }

    componentDidMount(){
        let chart = this.chart.current.getChart();
        this.props.startLiveData(this.props.id, this.props.rootView, chart);
        setTimeout(() => {
           if(chart) {
              chart.reflow();
              chart.redraw();
           }
        }, 100);
    }

    componentWillUnmount(){
        this.props.stopLiveData(this.props.id);
    }

}

const bindAction = dispatch => {
    return {
        startLiveData: (id, rootView, chart) => dispatch(actions.startLiveData(id, rootView, chart)),
        stopLiveData: (id) => dispatch(actions.stopLiveData(id)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    currentSite: state.sitetree.currentSite,
    chartData: state.livelinechart.instances[ownProps.id],
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
        };
        this.id = idPrefix + count;
        count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(mapStateToProps, bindAction)(LiveLineChart)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/LiveComponents/LiveLineChart/LiveLineChart.js